/**
 * Entry point for mybswhealth.
 */

// ---------------------------------------------------------
// polyfills for IE: order matters; keep them in this order.
//import "@babel/polyfill";
window.sanitizeHtml = require("sanitize-html-react");
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "fs";
// ---------------------------------------------------------

import React from "react";
import ReactDOM from "react-dom";
import './i18n';
import App from "./components/App";


function MyBSW(){
    return <App isHome={true} isPharmacy={false} />;
}

ReactDOM.hydrate(

    <App isHome={true} isPharmacy={false} />
    , document.getElementById("ReactContainer"));

// only enable hmr if running on a local dev's machine...
if (window.serverData.data.isLocalDev === true) {
    if (module && module.hot) {
        module.hot.accept();
    }
}

